import React from 'react';
import Plot from 'react-plotly.js';

// Mock data
const mockData = [
  {
    x: [1, 2, 3, 4, 5],
    y: [2, 4, 3, 5, 4],
    label: "Series A"
  },
  {
    x: [1, 2, 3, 4, 5],
    y: [1, 3, 5, 2, 4],
    label: "Series B"
  }
];

const PlotlyChart = ({ data = mockData }) => {
  const plotData = data.map(series => ({
    x: series.x,
    y: series.y,
    type: 'scatter',
    mode: 'lines+markers',
    name: series.label,
  }));

  const layout = {
    title: 'Multi-Series Plot',
    xaxis: { title: 'X Axis' },
    yaxis: { title: 'Y Axis' },
  };

  const config = {
    responsive: true,
    displayModeBar: true,
    modeBarButtonsToAdd: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d', 'resetScale2d'],
    displaylogo: false,
    toImageButtonOptions: {
      format: 'png',
      filename: 'plot_export',
      height: 600,
      width: 800,
      scale: 1
    }
  };

  return (
    <Plot
      data={plotData}
      layout={layout}
      config={config}
      style={{ width: '100%', height: '500px' }}
    />
  );
};

export default PlotlyChart;